import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import * as api from "./api";

export function useRedemptions(filters: api.RedemptionFilters) {
  return useInfiniteQuery({
    queryKey: ["portal", "redemptions", filters],
    queryFn: ({ pageParam }) =>
      api.listRedemptions(filters, pageParam as string | undefined),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.meta.next ?? undefined,
  });
}

export function useReverseRedemption() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      input,
      idempotencyKey,
    }: {
      id: string;
      input: api.ReverseRedemptionInput;
      idempotencyKey: string;
    }) => api.reverseRedemption(id, input, idempotencyKey),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ["portal", "redemptions"] });
      // SPEC-220 §4.2: revertir una recompensa restituye el saldo mediante
      // contrapartida (RN-07) — el saldo y los movimientos del miembro
      // también se muestran en PointsPanel y en la ficha (mismo criterio que
      // pointQueries.ts `usePointMutations`).
      void client.invalidateQueries({
        queryKey: ["portal", "member-movements"],
      });
      void client.invalidateQueries({ queryKey: ["portal", "member"] });
      void client.invalidateQueries({ queryKey: ["portal", "members"] });
    },
  });
}
